import React from 'react'

import {
  DEFAULT_LARGE_SNOWFLAKE_COUNT,
  DEFAULT_MEDIUM_SNOWFLAKE_COUNT,
  DEFAULT_SMALL_SNOWFLAKE_COUNT,
} from './snowflake-area.consts'
import { useSnowflakeArea } from './snowflake-area.model'
import type { SnowflakeAreaProps } from './snowflake-area.types'
import { SnowflakeAreaView } from './snowflake-area.view'

export const SnowflakeArea = ({
  smallCount = DEFAULT_SMALL_SNOWFLAKE_COUNT,
  mediumCount = DEFAULT_MEDIUM_SNOWFLAKE_COUNT,
  largeCount = DEFAULT_LARGE_SNOWFLAKE_COUNT,
  className,
  autoHideDuration,
  onAutoHideComplete,
}: SnowflakeAreaProps) => {
  const snowflakeAreaModel = useSnowflakeArea({
    smallCount,
    mediumCount,
    largeCount,
    autoHideDuration,
    onAutoHideComplete,
  })
  return <SnowflakeAreaView {...snowflakeAreaModel} className={className} />
}
